// (function($) {

// // PRELOADER
// $('#product_listing_preloader').hide();

// // PRODUCTS GRID-LIST SWITCH
// function productsGridList(){
// 	switch ( $.cookie("productsGridList") ) {
// 		case "grid":
// 			$("#toggle_grid").addClass("active");
// 			$("#toggle_list").removeClass("active");
// 			$(".product_listing_main").removeClass("view_list");
// 			break;

// 		case "list":
// 			$("#toggle_grid").removeClass("active");
// 			$("#toggle_list").addClass("active");
// 			$(".product_listing_main").addClass("view_list");
// 			break;

// 		default:
// 			$.cookie("productsGridList", "grid", { expires : 365 });
// 	};

// 	$("#toggle_grid").on("click", function(){
// 		$.cookie("productsGridList", "grid", { expires : 365 });

// 		if ( !$(this).hasClass("active") ) {
// 			$("#toggle_list").removeClass("active");
// 			$(this).addClass("active");
// 			$(".product_listing_main").removeClass("view_list");
// 		};
// 	});

// 	$("#toggle_list").on("click", function(){
// 		$.cookie("productsGridList", "list", { expires : 365 });

// 		if ( !$(this).hasClass("active") ) {
// 			$("#toggle_grid").removeClass("active");
// 			$(this).addClass("active");
// 			$(".product_listing_main").addClass("view_list");
// 		};
// 	});
// };



// // PRODUCTS QUANTITY AND SORTING
// function productsQuantitySort(show_query, sort_query){
// 	var queryURL = window.location.toString();

// // products quantity
// 	if ( queryURL.indexOf( 'view' ) > -1 ) {
// 		if ( queryURL.replace(/.*view/ , '').indexOf('&') > -1 ) {
// 			queryURL = queryURL.replace(/view=.*?&/ , 'view=' + show_query + '&');
// 		}
// 		else {
// 			queryURL = queryURL.replace(/view=.*/ , 'view=' + show_query);
// 		};
// 	}
// 	else if ( queryURL.indexOf( '?' ) > -1 ) {
// 		queryURL = queryURL + '&' + 'view=' + show_query;
// 	}
// 	else {
// 		queryURL = queryURL + '?' + 'view=' + show_query;
// 	};

// // products sort
// 	if ( queryURL.indexOf( 'sort_by' ) > -1 ) {
// 		if ( queryURL.replace(/.*sort_by/ , '').indexOf('&') > -1 ) {
// 			queryURL = queryURL.replace(/sort_by=.*?&/ , 'sort_by=' + sort_query + '&');
// 		}
// 		else {
// 			queryURL = queryURL.replace(/sort_by=.*/ , 'sort_by=' + sort_query);
// 		};
// 	}
// 	else if ( queryURL.indexOf( '?' ) > -1 ) {
// 		queryURL = queryURL + '&' + 'sort_by=' + sort_query;
// 	}
// 	else {
// 		queryURL = queryURL + '?' + 'sort_by=' + sort_query;
// 	};

// // pagination reload
// 	if ( queryURL.indexOf( 'page' ) > -1 ) {
// 		if ( queryURL.replace(/.*page/ , '').indexOf('&') > -1 ) {
// 			queryURL = queryURL.replace(/page=.*?&/ , 'page=' + 1 + '&');
// 		}
// 		else {
// 			queryURL = queryURL.replace(/page=.*/ , 'page=' + 1);
// 		};
// 	}
// 	else if ( queryURL.indexOf( '?' ) > -1 ) {
// 		queryURL = queryURL + '&' + 'page=' + 1;
// 	}
// 	else {
// 		queryURL = queryURL + '?' + 'page=' + 1;
// 	};

//     $('#product_listing_preloader').fadeIn(600);
//     $('#collection_sorted').animate({ opacity: 0 }, 400 );

// // loading products
// 	$('#collection_sorted').load( queryURL + ' #collection_sorted > *', function() {
// 		$.cookie("productsQuantity", show_query);
// 		$.cookie("productsSort", sort_query);

// 		productsGridList();
// 		enablePagination();
// 		currencyToggle();

// 	    $('#product_listing_preloader').fadeOut(300);
// 	    $('#collection_sorted').animate({ opacity: 1 }, 500 );
// 	});

// // enabling pagination
// 	function enablePagination() {
// 		$('#pagination a').each(function() {
// 			var pageNumber = $(this).attr('href').replace(/.*page=/, '').replace(/\&.*/, '');

// 			$(this).attr( 'href', queryURL + '&page=' + pageNumber );

// 			$(this).click( function() {
// 				$('#collection_sorted').load( $(this).attr( 'href' ) + ' #collection_sorted > *', function() {
// 					$.cookie("productsQuantity", show_query);
// 					$.cookie("productsSort", sort_query);

// 					productsGridList();
// 					enablePagination();
// 					currencyToggle();

// 				    $('#product_listing_preloader').fadeOut(300);
// 				    $('#collection_sorted').animate({ opacity: 1 }, 500 );
// 				});

// 				return false;
// 			});

// 		});
// 	};
// };



// function productsQuantitySelect(show_query){
// 	$('#show_products_select option').each(function(){
// 		if ( $(this).val() == show_query ) {
// 			$(this).attr("selected", "selected");
// 		};
// 	});
// };



// function productsSortSelect(sort_query){
// 	$('#sort_by_select option').each(function(){
// 		if ( $(this).val() == sort_query ) {
// 			$(this).attr("selected", "selected");
// 		};
// 	});
// };



// $(document).ready(function(){

// 	var cookieQuantity = $.cookie("productsQuantity");
// 	var cookieSort = $.cookie("productsSort");

// 	productsGridList();

// 	if ( cookieQuantity && cookieSort ) {
// 		productsQuantitySort( cookieQuantity, cookieSort );

// 		productsQuantitySelect( cookieQuantity );
// 		productsSortSelect( cookieSort );
// 	}
// 	else if ( cookieQuantity && !cookieSort ) {
// 		productsQuantitySort( cookieQuantity, 'manual' );

// 		productsQuantitySelect( cookieQuantity );
// 		productsSortSelect( 'manual' );
// 	}
// 	else if ( !cookieQuantity && cookieSort ) {
// 		productsQuantitySort( 6, cookieSort );

// 		productsQuantitySelect( 6 );
// 		productsSortSelect( cookieSort );
// 	}
// 	else {
// 		productsQuantitySort( 6, 'manual' );

// 		productsQuantitySelect( 6 );
// 		productsSortSelect( 'manual' );
// 	};

// 	$('#show_products_select').on('change', function() {
// 		productsQuantitySort( $(this).val(), $('#sort_by_select').val() );
// 	});

// 	$('#sort_by_select').on('change', function() {
// 		productsQuantitySort( $('#show_products_select').val(), $(this).val() );
// 	});

// });

// })(jQuery);



// MINI
!function(e){function t(){switch(e.cookie("productsGridList")){case"grid":e("#toggle_grid").addClass("active"),e("#toggle_list").removeClass("active"),e(".product_listing_main").removeClass("view_list");break;case"list":e("#toggle_grid").removeClass("active"),e("#toggle_list").addClass("active"),e(".product_listing_main").addClass("view_list");break;default:e.cookie("productsGridList","grid",{expires:365})}e("#toggle_grid").on("click",function(){e.cookie("productsGridList","grid",{expires:365}),e(this).hasClass("active")||(e("#toggle_list").removeClass("active"),e(this).addClass("active"),e(".product_listing_main").removeClass("view_list"))}),e("#toggle_list").on("click",function(){e.cookie("productsGridList","list",{expires:365}),e(this).hasClass("active")||(e("#toggle_grid").removeClass("active"),e(this).addClass("active"),e(".product_listing_main").addClass("view_list"))})}function i(i,o){function c(){e("#pagination a").each(function(){var a=e(this).attr("href").replace(/.*page=/,"").replace(/\&.*/,"");e(this).attr("href",s+"&page="+a),e(this).click(function(){return e("#collection_sorted").load(e(this).attr("href")+" #collection_sorted > *",function(){e.cookie("productsQuantity",i),e.cookie("productsSort",o),t(),c(),currencyToggle(),e("#product_listing_preloader").fadeOut(300),e("#collection_sorted").animate({opacity:1},500)}),!1})})}var s=window.location.toString();s=s.indexOf("view")>-1?s.replace(/.*view/,"").indexOf("&")>-1?s.replace(/view=.*?&/,"view="+i+"&"):s.replace(/view=.*/,"view="+i):s.indexOf("?")>-1?s+"&view="+i:s+"?view="+i,s=s.indexOf("sort_by")>-1?s.replace(/.*sort_by/,"").indexOf("&")>-1?s.replace(/sort_by=.*?&/,"sort_by="+o+"&"):s.replace(/sort_by=.*/,"sort_by="+o):s.indexOf("?")>-1?s+"&sort_by="+o:s+"?sort_by="+o,s.indexOf("page")>-1?s=s.replace(/.*page/,"").indexOf("&")>-1?s.replace(/page=.*?&/,"page=1&"):s.replace(/page=.*/,"page=1"):s+=s.indexOf("?")>-1?"&page=1":"?page=1",e("#product_listing_preloader").fadeIn(600),e("#collection_sorted").animate({opacity:0},400),e("#collection_sorted").load(s+" #collection_sorted > *",function(){e.cookie("productsQuantity",i),e.cookie("productsSort",o),t(),c(),currencyToggle(),e("#product_listing_preloader").fadeOut(300),e("#collection_sorted").animate({opacity:1},500)})}function o(t){e("#show_products_select option").each(function(){e(this).val()==t&&e(this).attr("selected","selected")})}function c(t){e("#sort_by_select option").each(function(){e(this).val()==t&&e(this).attr("selected","selected")})}e("#product_listing_preloader").hide(),e(document).ready(function(){var s=e.cookie("productsQuantity"),a=e.cookie("productsSort");t(),s&&a?(i(s,a),o(s),c(a)):s&&!a?(i(s,"manual"),o(s),c("manual")):!s&&a?(i(6,a),o(6),c(a)):(i(6,"manual"),o(6),c("manual")),e("#show_products_select").on("change",function(){i(e(this).val(),e("#sort_by_select").val())}),e("#sort_by_select").on("change",function(){i(e("#show_products_select").val(),e(this).val())})})}(jQuery);